import ExtendedBio from "./ExtendedBio";

export default ExtendedBio;